module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#group",
      toString: function () {
        return this.url;
      }
    }